"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestGeneration = void 0;
const react_1 = require("react");
/**
 * Guards async state writes against out-of-order responses.
 *
 * Fetch-then-setState hooks race when their params (sensorId, date range, group)
 * change while a request is in flight: the OLD request can resolve LAST and
 * overwrite the new params' data. Call `beginRequest()` when a fetch starts and
 * check the returned `isCurrent()` before every setState after an await —
 * a stale request sees false and must not commit.
 *
 * ```ts
 * const beginRequest = useRequestGeneration();
 * const fetchData = async () => {
 *   const isCurrent = beginRequest();
 *   const result = await api.fetch(params);
 *   if (!isCurrent()) return;
 *   setData(result);
 * };
 * ```
 */
function useRequestGeneration() {
    const seqRef = (0, react_1.useRef)(0);
    return (0, react_1.useCallback)(() => {
        const id = ++seqRef.current;
        return () => id === seqRef.current;
    }, []);
}
exports.useRequestGeneration = useRequestGeneration;
